import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';


// {
//     "key": "account_primary_color",
//     "label": "Primärfarbe",
//     "description": "Primärfarbe für die Darstellung, bsp. in E-Mails.",
//     "type": "Color",
//     "defaultValue": "#DAFF00",
//     "currentValue": "#DAFF00"
// }

@Component({
  selector: "nx-color-picker",
  templateUrl: "./nx-color-picker.component.html",
  styleUrls: ["./nx-color-picker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NxColorPickerComponent),
      multi: true
    }
  ]
})
export class NxColorPickerComponent implements ControlValueAccessor{

  public colorForm: FormGroup;
   _field: any;
  @Input() set field(field: any) {
    this._field = field;
    this.buildOptions();
  };

  // public addressForm: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
  }


  /** value accessor */
  writeValue(address: any): void {
    // we initialize the form control with the current value that
    // should be sufficient to display the current value
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.colorForm.disable();
    } else {
      this.colorForm.enable();
    }
  }

  buildOptions() {
    if(this._field && !this.colorForm) {
      this.colorForm = new FormGroup({});
      let formControl = this.fb.control(this._field.currentValue);
      this.colorForm.addControl('colorFormControl', formControl);
      this.colorForm.valueChanges.subscribe(value => {
        this.propagateChange(value?.colorFormControl);
      });
    }
  }

  reset() {
    this.colorForm.get('colorFormControl').setValue(this._field.defaultValue);
  }
}
